import { Component } from '@angular/core';

@Component({
  selector: 'app-holdeo-principal',
  templateUrl: './holdeo-principal.component.html',
  styleUrls: ['./holdeo-principal.component.css']
})
export class HoldeoPrincipalComponent {

  tipoHoldeo: number = 4;

  abrirTipoHoldeo(i: number){
    this.tipoHoldeo = i;
  }

  volver(){
    this.tipoHoldeo = 4;
  }

}
